var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-block"},[_c('img',{staticStyle:{"margin":"auto"},attrs:{"width":"100","src":require("@/assets/icon/nodata/no_data.svg"),"alt":"","srcset":""}}),_c('span',[_vm._v(_vm._s(_vm.emptyText ?? _vm.$t('common.table.empty2.text')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }